/// <reference path="../../_ext/Bases/TransDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class MeltingDialog extends _Ext.TransDialog<MeltingRow, any> {
        protected getFormKey() { return MeltingForm.formKey; }
        protected getIdProperty() { return MeltingRow.idProperty; }
        protected getLocalTextPrefix() { return MeltingRow.localTextPrefix; }
        protected getNameProperty() { return MeltingRow.nameProperty; }
        protected getService() { return MeltingService.baseUrl; }
        protected getDeletePermission() { return MeltingRow.deletePermission; }
        protected getInsertPermission() { return MeltingRow.insertPermission; }
        protected getUpdatePermission() { return MeltingRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new MeltingForm(this.idPrefix);
        public Closing: boolean;

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            q.initItemEditor(this, this.form.ReturnDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ReturnDetails);
            q.setTextRightAlign(this.form.Purity);    
            q.setTextRightAlign(this.form.ReceivableWeight);
            q.setTextRightAlign(this.form.RequiredAlloyTemp); 
            q.setTextRightAlign(this.form.IssuedAlloy);
            q.setTextRightAlign(this.form.ReceivedWeight);
            q.setTextRightAlign(this.form.Loss);
            q.setTextRightAlign(this.form.LossPercent);
            q.HideCategoryLable(this.element);
            q.SetCategoryFullWidth(this.form.TransDate);
            q.SetCategorySixColumn(this.form.ItemDetails);
            q.SetCategorySixColumn(this.form.ReturnDetails);
            q.SetCategoryFullWidth(this.form.Remark);
            //q.hideCaption(this.form.Posted);




            this.form.DepartmentId.changeSelect2(e => {
                this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            });

            this.form.BaseItemTypeId.changeSelect2(e => {
                this.form.KaratId.cascadeField="Num1";
                this.form.KaratId.cascadeValue=this.form.BaseItemTypeId.value;
            });
            this.form.KaratId.changeSelect2(e => {
                var KaratId=this.form.KaratId.value;
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                this.form.Purity.value = std;
            });
            
            //this.form.Weight.changeSelect2(e => {
            //    this.form.RequiredPureWeight.value = this.form.Weight.value * this.form.Purity.value;
            //    this.form.RequiredAlloy.value = this.form.Weight.value - this.form.RequiredPureWeight.value
            //});

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                this.calculateIssuedData();
                
            });

            (this.form.ReturnDetails.view as any).onRowCountChanged.subscribe(() => {
                this.calculateReceivedData();
            });

        }

        public calculateIssuedData() {
            var Items = this.form.ItemDetails.getItems();
            if (Items.length > 0) {

                q.showAndDisableField(this.form.KaratId);
                q.showAndDisableField(this.form.MetalColorId);


                var weight = 0, purity = 0, pureweight = 0, alloyrequired = 0, receivableweight = 0;
                var alloyweight = 0;
                for (var i = 0; i < Items.length; i++) {

                    var item = Items[i];
                    if (item.ProductTypeId != 10) {
                        weight += item.Weight;
                        purity += item.Purity;
                        alloyrequired += item.AlloyRequired;
                        receivableweight += item.ReceivableWeight;
                    } else if (item.ProductTypeId == 10) {
                        alloyweight += item.Weight;
                        receivableweight += item.ReceivableWeight;
                    }

                }
                pureweight = (weight * purity);
                this.form.ReceivableWeight.value = receivableweight;
                this.form.IssuedAlloy.value = alloyweight;
                this.form.RequiredAlloyTemp.value = alloyrequired;
            } else if (Items.length==0) {
                q.showAndEnableField(this.form.KaratId);
                q.showAndEnableField(this.form.MetalColorId);
                this.form.ReceivableWeight.value = 0;
                this.form.IssuedAlloy.value = 0;
                this.form.RequiredAlloyTemp.value = 0;
            }
        }

        public calculateReceivedData() {
            var Items = this.form.ReturnDetails.getItems();
            if (Items.length > 0) {

                q.showAndDisableField(this.form.KaratId);
                q.showAndDisableField(this.form.MetalColorId);
                var weight = 0;
                for (var i = 0; i < Items.length; i++) {

                    var item = Items[i];
                    weight += item.Weight;

                }
                this.form.ReceivedWeight.value = weight;
                this.form.Loss.value = (this.form.ReceivableWeight.value - this.form.ReceivedWeight.value)
                this.form.LossPercent.value = (this.form.Loss.value / (this.form.ReceivableWeight.value)) * 100;
            } else if (Items.length == 0) {
                q.showAndEnableField(this.form.KaratId);
                q.showAndEnableField(this.form.MetalColorId);
                this.form.ReceivedWeight.value = 0;
                this.form.Loss.value = 0;
                this.form.LossPercent.value = 0;
            }
        }
        onDialogClose() {
            super.onDialogClose();
            this.Closing = true;

        }

        validateBeforeSave() {
            var receivableweight = this.form.ReceivableWeight.value;
            var receivedweight = this.form.ReceivedWeight.value;
            var loss = this.form.Loss.value;
            if (receivableweight != (receivedweight + loss)) {
                q.Alert('Invalid Entry', 'Total Weights do not Match', 1000, false);
                return false;
            }
            return true;
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
           

            var postingpermission = Q.Authorization.hasPermission('Inventory:Melting:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    MeltingService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }

        // #region Edit Delete Validation
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            if (this.entity.IsPosted) {
                var returnproduct = this.form.ReturnDetails.getItems()[0];

                let CurrentStock: Stock.StockItemRow;

                Stock.StockItemService.GetProductDetails({
                    ProductId: returnproduct.ProductId,
                    AttributeId: returnproduct.AttributeId,
                },
                    response =>
                        CurrentStock = response.Entity,
                    { async: false }
                );
                if (CurrentStock.Weight < this.form.ReceivedWeight.value) {

                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;

                } else {
                    Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                    this.form.ItemDetails.canUpdate = 1;
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;
                    self.updateInterface();
                    self.updateTitle();
                }
            }
            else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            var returnproduct = this.form.ReturnDetails.getItems()[0];

            let CurrentStock: Stock.StockItemRow;

            Stock.StockItemService.GetProductDetails({
                ProductId: returnproduct.ProductId,
                AttributeId: returnproduct.AttributeId,
            },
                response =>
                    CurrentStock = response.Entity,
                { async: false }
            );
            if (CurrentStock.Weight < this.form.ReceivedWeight.value) {
                   Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return; 
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                       MeltingService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        } 
    }
}